import { Locale, Scope } from '@headless-workspace/config';
import { HealthServiceStatus, HealthStatusValue } from '../../index';

// Calculate overall system status
const getOverallStatus = (healthStatus: HealthStatusValue): HealthServiceStatus['status'] => {
    const hasDownService = Object.values(healthStatus).some((service) => service.status === 'DOWN');

    return hasDownService ? 'DOWN' : 'UP';
};

type StatusCounts = {
    up: number;
    down: number;
    total: number;
};
// Count services by status
const getStatusCounts = (healthStatus: HealthStatusValue): StatusCounts => {
    const services = Object.values(healthStatus);
    const up = services.filter((service) => service.status === 'UP').length;
    const down = services.filter((service) => service.status === 'DOWN').length;

    return { up, down, total: services.length };
};

const getScopeWithLocale = (locale: Locale, scope: Scope): string => {
    return `${scope.toUpperCase()} ${locale}`;
};

export const HealthCheckStatusHelpers = {
    getOverallStatus,
    getStatusCounts,
    getScopeWithLocale,
};
